import { pgMessage } from '../../message/index'
/***
 * 新开窗口
 */
export async function openWindow({ parameter }) {
  const win1 = window.open(parameter.path)
  if (!win1 || !win1.location) {
    pgMessage.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
  }
}
